<template>
  <div id="realTimeMap">
    <v-container fluid class="overrideContainer">
      <v-row>
        <v-col md="9" cols="12" lg="9" class="overrideCol">
          <div class="mapWrapper">
            <template v-if="mapType !== null">
                <GoogleRouteOptimizationComponent v-if="mapType == 1" />
                <LeafletRouteOptimizationComponent v-if="mapType == 0"/>

                 <v-card class="mt-3 ml-6">
          <label class="text-caption ml-3" v-if="mrpReport">
            {{ mrpReport[0].nazivTabele }} - <span v-html="mrpReport[0].opis"></span>
          </label>
         <v-simple-table v-if="mrpReport" dense>
            <template v-slot:default>
              <thead>
                <tr >
                  <th style="" v-for="(header, index) in mrpReport[0].table.tableHeader" :key="'table' + index">
                    {{ $t(`optimization.headers.${header}`) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in mrpReport[0].table.tableBody"
                  :key="'body' + index"
                >
                  <td :style="'background-color:' + column.style" :key="'column'+index" v-for="(column, index) in row.stavke">{{ column.value }}</td>
                </tr>
              </tbody>
            </template>
        </v-simple-table>
       </v-card>
            </template>
            
            <div v-else>
              Initializing map...
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" lg="3">
           <v-row no-gutters class="pl-4 pt-3 pr-4">
               <v-col cols="12">
                 <v-autocomplete outlined dense hide-details :items="savedRoutes" v-model="selectedOptimization" :label="$t('optimization.saved')" item-text="name" item-value="id"/>
                 <v-text-field :error-messages="nameError" outlined dense v-model="name" :label="$t('optimization.name')"></v-text-field>
               </v-col>
               <v-col cols="12">
                 <v-autocomplete multiple outlined dense hide-details :items="drivers" v-model="selectedDrivers" :label="$t('drivers')" item-text="name" item-value="id" />
               </v-col>
               <v-col cols="12" class="">
                  <v-checkbox
                    dense
                    color="primary"
                    v-model="startPointAndEndPointAreSame"
                    :label="$t('optimization.startPointAndEndPointAreSame')"
                  ></v-checkbox>
               </v-col>
               <v-col cols="12" class="mb-3">
                  <v-row no-gutters>
                      <v-col cols="12">
                         <v-btn small class="mb-1" :color="sourceSelecting ? 'primary' : 'default'" @click="beginSourceSelection">{{ $t("optimization.startPoint") }}</v-btn> <br>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters v-if="sourceSelecting">
                            <v-col cols="6" class="pr-1"><v-autocomplete hide-details :items="filteredLocations" @change="chooseSource" item-text="name" item-value="id" :label="$t('optimization.chooseLocation')" outlined dense></v-autocomplete></v-col>
                            <v-col cols="6" class="pt-3 pl-3"> <label class="text-caption"> <LocationFinder @locationChoosen='chooseLocationFromApi($event, "src")'></LocationFinder>  {{ $t('optimization.mapClick') }}</label></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="6" class="pr-1">
                            <v-text-field outlined :disabled="!sourceSelecting" hide-details dense type="number" @input="updateSource" v-model="sourceLat" :label="$t('lat')"/>
                          </v-col>
                           <v-col cols="6">
                            <v-text-field outlined :disabled="!sourceSelecting" hide-details type="number" dense @input="updateSource" v-model="sourceLng" :label="$t('lng')"/>
                          </v-col>
                        </v-row>
                       
                    </v-col>
                      <v-col cols="12">
                        <label v-if="markers && markers.length" class="text-caption"> {{ $t("startAddress") }}: {{ markers[0].desc }} </label>
                      </v-col>
                  </v-row>
               </v-col>
               <v-col cols="12">
                  <v-row no-gutters>
                       <v-btn small :color="destinationSelecting ? 'primary' : 'default'"  @click="beginDestinationSelection">{{ $t("optimization.pickDestination") }}</v-btn>
                       <v-col cols="12">
                        <v-row no-gutters v-if="destinationSelecting">
                            <v-col cols="6"><v-autocomplete :items="filteredLocations" @change="chooseLocation" item-text="name" item-value="id" :label="$t('optimization.chooseLocation')" outlined dense></v-autocomplete></v-col>
                            <v-col cols="6" class="pt-3 pl-3">  <LocationFinder @locationChoosen='chooseLocationFromApi($event, "dest")'></LocationFinder> <label class="text-caption">{{ $t('optimization.mapClick') }}</label></v-col>
                        </v-row>
                       </v-col>
                       <v-col cols="12">
                         <v-btn small color="primary" @click="clearZoom" v-if="routeSelected">{{ $t("optimization.showAll") }}</v-btn>
                       </v-col>
                        <v-col cols="12" v-for="(destination, index) in destinations" :key="'lantlngs-' + index">
                          <v-row no-gutters>
                            <v-col cols="1">
                              <v-icon :disabled="!destinationSelecting" color="primary" style="margin-top:20px;cursor:pointer" @click="zoomToPoint(destinationPoints[index] ? destinationPoints[index].route : destination, index)" small>mdi-magnify</v-icon>
                           </v-col>
                            <v-col cols="5" class="pr-1">
                            <v-text-field outlined readonly :disabled="!destinationSelecting" hide-details dense :persistent-hint="true" type="number" :value="destination.latlng.lat" :label="$t('lat')"/>
                          </v-col>
                           <v-col cols="5">
                            <v-text-field outlined readonly :disabled="!destinationSelecting" hide-details type="number" dense :persistent-hint="true" :value="destination.latlng.lng" :label="$t('lng')"/>
                          </v-col>
                          <v-col cols="1">
                              <v-icon :disabled="!destinationSelecting" small color="red" style="margin-top:20px;cursor:pointer" @click="removeDestination(destination)" class="ml-3">mdi-close-circle-outline</v-icon>
                          </v-col>
                          <template v-if="destinationPoints[index]" >
                             <label :style="'background-color:' + destinationPoints[index].color + ';height:17px'" class="ml-9 mt-1" >&nbsp;&nbsp;&nbsp;</label> <label class="ml-1 text-caption mt-1" > {{ destinationPoints[index].place }} ({{ destinationPoints[index].distance }})</label>
                          </template>
                          </v-row>
                        </v-col>
                  </v-row>
               </v-col>
               <v-col cols="12" class="mt-5" v-if="!startPointAndEndPointAreSame">
                  <v-row no-gutters>
                      <v-col cols="12">
                         <v-btn small class="mb-1" :color="endPointSelecting ? 'primary' : 'default'" @click="beginEndPointSelection">{{ $t("optimization.endPoint") }}</v-btn> <br>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters v-if="endPointSelecting">
                            <v-col cols="6" class="pr-1"><v-autocomplete hide-details :items="filteredLocations" @change="chooseEndPoint" item-text="name" item-value="id" :label="$t('optimization.chooseLocation')" outlined dense></v-autocomplete></v-col>
                            <v-col cols="6" class="pt-3 pl-3"> <label class="text-caption"> <LocationFinder @locationChoosen='chooseLocationFromApi($event, "endPt")'></LocationFinder>  {{ $t('optimization.mapClick') }}</label></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="6" class="pr-1">
                            <v-text-field outlined :disabled="!endPointSelecting" hide-details dense type="number" @input="updateEndPoint" v-model="endPointLat" :label="$t('lat')"/>
                          </v-col>
                           <v-col cols="6">
                            <v-text-field outlined :disabled="!endPointSelecting" hide-details type="number" dense @input="updateEndPoint" v-model="endPointLng" :label="$t('lng')"/>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <template v-if="destinationPoints && destinationPoints.length > 0 && !startPointAndEndPointAreSame && endPoint">
                            <label :style="'background-color:' + destinationPoints[destinationPoints.length - 1].color + ';height:17px'" class="ml-9 mt-1"> 
                            &nbsp;&nbsp;&nbsp; 
                            </label>
                            <br/>
                            <label class="ml-1 text-caption mt-1" > {{ $t("startAddress") }}: {{ destinationPoints[destinationPoints.length - 1].place }}</label>
                        </template>
                      </v-col>
                  </v-row>
               </v-col>
               <v-col cols="12" class="mt-4">
                   <v-btn v-if="findRouteCondition" :disabled="loading" :loading="loading" color="success" small @click="findOptimizedRoutes">{{ $t('optimization.find') }}</v-btn>
                   <v-btn class="ml-2" v-if="findRouteCondition" :disabled="loading" color="warning" small @click="reset">{{ $t('optimization.reset') }}</v-btn>
                   <v-btn class="ml-2" v-if="destinationPoints && destinationPoints.length && findRouteCondition" :disabled="loading || saving" :loading="saving" color="success" small @click="saveOptimization">{{ $t('save') }}</v-btn>
                   <v-btn class="ml-2" v-if="destinationPoints && destinationPoints.length && selectedOptimization && findRouteCondition" :disabled="loading" color="warning" small @click="deleteOptimization">{{ $t('del') }}</v-btn>
                   <v-card
                    class="mx-auto"
                    max-width="500"
                  >
                  </v-card>
               </v-col>
               <v-col cols="12" v-if="serverError">
                 <label style="color:red" class="text-caption"> {{ $t("optimization.serverError") }} </label>
               </v-col>
           </v-row>
            
            
        </v-col>
      </v-row>
      
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/store'
import mapMixin from '../mapMixin.js'
import httpClient from '@/api/httpClient'
import LocationFinder from './LocationFinder'
export default {
  name: 'BaseRouteOptimizationComponent',
  data() {
    return {
      isDeleteMode: false,
      loading: false,
      savedRoutes: [],
      selectedOptimization: undefined,
      drivers: [],
      selectedDrivers: [],
      sourceLat: undefined,
      sourceLng: undefined,
      name: undefined,
      saving: false,
      nameError: [],
      locations: [],
      choosenLocations: [],
      serverError: false,
      startPointAndEndPointAreSame: true,
      endPointLat: undefined,
      endPointLng: undefined,
      totalDistance: 0
    }
  },
  mixins: [mapMixin],
  components: {
    LeafletRouteOptimizationComponent: () =>
      import('./LeafletRouteOptimization'),
    GoogleRouteOptimizationComponent: () => import('./GoogleRouteOptimization'),
    LocationFinder
  },
  mounted() {
    this.loadDestinations()
    this.loadDrivers()
    httpClient.get('/locations').then(response => {
      response.data.unshift({
        name: this.$t('choose'),
        value: null
      })
      this.locations = response.data
    })
  },
  beforeDestroy() {
    this.clearSelection()
  },
  computed: {
    ...mapState('optimization', [
      'sourceSelecting',
      'destinationSelecting',
      'source',
      'destinations',
      'markers',
      'routes',
      'mrpReport',
      'selectedRoute',
      'endPointSelecting',
      'endPoint'
    ]),
    routeSelected() {
      return this.selectedRoute != null
    },
    filteredLocations() {
      return this.locations.filter(
        x => !this.choosenLocations.some(y => y.id == x.id)
      )
    },
    destinationPoints() {
      let destinations = []
      for (let i = 1; i < this.markers.length; i++) {
        destinations.push({
          place: this.markers[i].desc.split(';')[0],
          color: this.routes[i - 1].color,
          distance:
            parseFloat(
              this.markers[i].desc
                .split('=')[1]
                .split('m.;')[0]
                .trim()
                .replace(',', '') / 1000
            ).toFixed(2) + ' km',
          route: this.routes[i - 1]
        })
      }
      return destinations
    },
    findRouteCondition() {
      if(this.startPointAndEndPointAreSame){
        return this.source && this.destinations.length
      }
      else{
        return this.source && this.destinations.length && this.endPoint
      }
    }
  },
  methods: {
    chooseLocationFromApi(event, usage) {
      let url = 'optimization/'
      switch(usage){
        case 'src': url += 'setSource'
        break;
        case 'dest': url += 'addDestination'
        break;
        case 'endPt': url += 'setEndPoint'
        break;
      }
      store.dispatch(url, {
        latlng: {
          lat: event.latitude,
          lng: event.longitude
        }
      })
    },
    clearZoom() {
      store.dispatch('optimization/clearSelection')
    },
    reset() {
      store.dispatch('optimization/reset')
    },
    chooseLocation(id) {
      if (!id || typeof id == 'string') {
        return
      }
      var choosen = this.locations.filter(x => x.id == id)[0]
      this.choosenLocations.push(choosen)
      store.dispatch('optimization/addDestination', {
        latlng: {
          lat: choosen.latitude,
          lng: choosen.longitude
        },
        id: choosen.id
      })

      store.dispatch(
        'optimization/setSelectedRoute',
        this.destinations.map(x => [x.latlng.lat, x.latlng.lng])
      )
    },
    chooseSource(id) {
      if (!id || typeof id == 'string') {
        store.dispatch('optimization/setSource', {
          latlng: {
            lat: undefined,
            lng: undefined
          }
        })
        return
      }
      var choosen = this.locations.filter(x => x.id == id)[0]
      store.dispatch('optimization/setSource', {
        latlng: {
          lat: choosen.latitude,
          lng: choosen.longitude
        }
      })
    },
    deleteOptimization() {
      httpClient
        .delete('routeoptimization/' + this.selectedOptimization)
        .then(() => {
          this.clearSelection()
          this.selectedOptimization = undefined
          this.loadDestinations()
        })
    },
    loadDestinations() {
      httpClient.get('/routeoptimization').then(result => {
        result.data.unshift({
          name: 'Izaberite...',
          id: null
        })
        this.savedRoutes = result.data
      })
    },
    loadDrivers() {
      httpClient.get('/drivers').then(result => {
        result.data.unshift({
          name: 'Izaberite...',
          id: null
        })
        this.drivers = result.data
      })
    },
    clearSelection() {
      store.dispatch('optimization/clearDestinations')
      store.dispatch('optimization/setRoutes', { routes: [], markers: [] })
      store.dispatch('optimization/setSource', undefined)
      store.dispatch('optimization/endPoint', undefined)
    },
    saveOptimization() {
      this.nameError = []
      this.saving = true
      const itemToSave = {
        name: this.name,
        driverIds: this.selectedDrivers,
        routeData: JSON.stringify({
          routes: this.routes,
          markers: this.markers,
          mrpReport: this.mrpReport,
          existEndPoint: !this.startPointAndEndPointAreSame,
          totalDistance: this.mrpReport[0].table.tableBody[this.mrpReport[0].table.tableBody.length - 1].stavke.at(-2).value.slice(0, -4).replace(/,/g, '')
        })
      }

      if (this.selectedOptimization) {
        httpClient
          .put('/routeoptimization/' + this.selectedOptimization, itemToSave)
          .then(() => {
            this.loadDestinations()
            this.saving = false
          })
          .catch(error => {
            if (error.response.status == 422) {
              this.nameError = ['Naziv je već u upotrebi.']
            }
            this.saving = false
          })
      } else {
        if (!this.name) {
          this.nameError = ['Naziv optimizacije je obavezan.']
          this.saving = false
          return
        }

        httpClient
          .post('/routeoptimization', itemToSave)
          .then(() => {
            this.loadDestinations()
            this.saving = false
          })
          .catch(error => {
            if (error.response.status == 422) {
              this.nameError = ['Naziv je već u upotrebi.']
            }
            this.saving = false
          })
      }
    },
    zoomToPoint(latlng, index) {
      store.dispatch('optimization/setSelectedRoute', {
        route: latlng.coordinates ? latlng.coordinates : [latlng.latlng],
        index
      })
    },
    removeDestination(marker) {
      if (marker.id) {
        this.choosenLocations = this.choosenLocations.filter(
          x => x.id != marker.id
        )
      }

      var routeIndex = this.destinations.indexOf(marker)
      this.destinations.splice(routeIndex, 1)
      store.dispatch('optimization/removeRoute', routeIndex)
    },
    updateSource() {
      store.dispatch('optimization/setSource', {
        latlng: {
          lat: this.sourceLat,
          lng: this.sourceLng
        }
      })
    },
    beginSourceSelection() {
      store.dispatch('optimization/setSourceSelecting', true)
    },
    beginDestinationSelection() {
      store.dispatch('optimization/setDestinationSelecting', true)
    },
    findOptimizedRoutes() {
      this.loading = true
      this.serverError = false

      var requestObject = {
        source: {
          latitude: this.source.latlng.lat,
          longitude: this.source.latlng.lng
        },
        destinations: [],
        isCircular: this.startPointAndEndPointAreSame
      }

      for (const d of this.destinations) {
        requestObject.destinations.push({
          latitude: d.latlng.lat,
          longitude: d.latlng.lng
        })
      }

      if(this.startPointAndEndPointAreSame){
        requestObject.destinations.push({
          latitude: this.source.latlng.lat,
          longitude: this.source.latlng.lng
        })
      }
      else{
        requestObject.destinations.push({
          latitude: this.endPoint.latlng.lat,
          longitude: this.endPoint.latlng.lng
        })
      }

      httpClient
        .post('routeoptimizer/optimize', requestObject)
        .then(response => {
          if (!response.data.routes.length) {
            this.loading = false
            this.serverError = true
          }

          response.data.routes.forEach(x => {
            x.visible = true
          })

          response.data.mrpReport[0].table.tableHeader.unshift('Path')

          store.dispatch('optimization/setRoutes', response.data)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.serverError = true
        })
    },
    beginEndPointSelection(){
      store.dispatch('optimization/setEndPointSelecting', true)
    },
    chooseEndPoint(id) {
      if (!id || typeof id == 'string') {
        store.dispatch('optimization/setEndPoint', {
          latlng: {
            lat: undefined,
            lng: undefined
          }
        })
        return
      }
      var choosen = this.locations.filter(x => x.id == id)[0]
      store.dispatch('optimization/setEndPoint', {
        latlng: {
          lat: choosen.latitude,
          lng: choosen.longitude
        }
      })
    },
    updateEndPoint() {
      store.dispatch('optimization/setEndPoint', {
        latlng: {
          lat: this.endPointLat,
          lng: this.endPointLng
        }
      })
    }
  },
  watch: {
    isDeleteMode: {
      handler() {
        store.dispatch('optimization/setIsDeleteMode', this.isDeleteMode)
      }
    },
    source: {
      handler() {
        if (!this.source) {
          this.sourceLat = ''
          this.sourceLng = ''
          return
        }
        this.sourceLat = this.source.latlng.lat
        this.sourceLng = this.source.latlng.lng
      }
    },
    selectedOptimization: {
      handler() {
        if (!this.selectedOptimization) {
          this.clearSelection()
          return
        }

        const optimization = this.savedRoutes.filter(
          x => x.id == this.selectedOptimization
        )[0]

        this.name = optimization.name
        this.selectedDrivers = optimization.driverIds
        const routeData = JSON.parse(optimization.routeData)
        store.dispatch('optimization/setRoutes', routeData)
        store.dispatch('optimization/setSource', {
          latlng: {
            lat: routeData.markers[0].latitude,
            lng: routeData.markers[0].longitude
          }
        })

        let existEndPoint = routeData.existEndPoint
        if(existEndPoint) {
          store.dispatch('optimization/setEndPoint', {
            latlng: {
              lat: routeData.markers[routeData.markers.length - 1].latitude,
              lng: routeData.markers[routeData.markers.length - 1].longitude
            }
          })
        }

        this.startPointAndEndPointAreSame = !existEndPoint

        let avaliibleDestinations = !existEndPoint ? routeData.markers.length : routeData.markers.length - 1

        store.dispatch('optimization/clearDestinations')
        for (let i = 1; i < avaliibleDestinations; i++) {
          store.dispatch('optimization/addDestination', {
            latlng: {
              lat: routeData.markers[i].latitude,
              lng: routeData.markers[i].longitude
            }
          })
        }

      }
    },
    endPoint: {
      handler() {
        if (!this.endPoint) {
          this.endPointLat = ''
          this.endPointLng = ''
          return
        }
        this.endPointLat = this.endPoint.latlng.lat
        this.endPointLng = this.endPoint.latlng.lng
      }
    }
  }
}
</script>

<style scoped>
.overrideContainer {
  padding: 0px !important;
}

.overrideCol {
  padding: 0px !important;
}
</style>
